"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportGLTF = exportGLTF;
var _GLTFExporter = require("three/examples/jsm/exporters/GLTFExporter");
function exportGLTF(input) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "scene";
  var gltfExporter = new _GLTFExporter.GLTFExporter();
  var options = {
    binary: true,
    includeCustomExtensions: true
  };
  gltfExporter.parse(input, function (result) {
    if (result instanceof ArrayBuffer) {
      saveArrayBuffer(result, filename + ".glb");
    } else {
      var output = JSON.stringify(result, null, 2);
      saveString(output, filename + ".gltf");
    }
  }, options);
}
function save(blob, filename) {
  var link = document.createElement("a");
  link.style.display = "none";
  document.body.appendChild(link); // Firefox workaround, see #6594
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  document.body.removeChild(link);
  // URL.revokeObjectURL( url ); breaks Firefox...
}

function saveString(text, filename) {
  save(new Blob([text], {
    type: "text/plain"
  }), filename);
}
function saveArrayBuffer(buffer, filename) {
  save(new Blob([buffer], {
    type: "application/octet-stream"
  }), filename);
}